import { FC } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { useBlockAccountMutation } from 'pages/Accounts/api/accounts';
import { isSuccess } from 'utils/responseStatus';

type Props = {
  onRefresh: () => void;
  isBlocked: boolean;
  id: number;
};

export const BlockAccountModal: FC<Props> = ({ onRefresh, isBlocked, id }) => {
  const { hideModal } = useModal();

  const [blockAccount] = useBlockAccountMutation();

  const handleSubmit = () => {
    blockAccount({ id }).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Учетная запись успешно обновлена', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title={isBlocked ? 'Разблокировать пользователя' : 'Заблокировать пользователя'}
      visible
      isLoadingSubmit={false}
      width={400}
      height="auto"
      textConfirm="Подтвердить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
    >
      {isBlocked ? 'Разблокировать' : 'Заблокировать'} пользователя?
    </ModalForm>
  );
};
